import React from 'react';

import { createComponent, Layout, Header, Label, enums, PropTypes } from 'console-kit';
import authStatics from '../../../common/static';
import AuthImageLogo from '../../../components/AuthImageLogo';

const NeedsSsoPanel = createComponent({
  displayName: 'NeedsSsoPanel',
  propTypes:   {
    ssoLink: PropTypes.string,
  },
  defaultProps: {
    ssoLink: undefined,
  },
  render(props) {
    return (
      <div className={authStatics.SCREEN_CLASSES}>
        <Layout isFluidHeight>
          <Layout.Row>
            <Layout.Column textAlign={enums.textAlignments.CENTER}>
              <AuthImageLogo />
            </Layout.Column>
          </Layout.Row>

          <Layout.Row>
            <Layout.Column textAlign={enums.textAlignments.LEFT}>
              <Header
                text="Sorry"
                isDividing={false}
                font={{
                  emphasis: enums.font.emphasis.NORMAL,
                }}
                size={enums.sizes.X6}
              />
            </Layout.Column>
          </Layout.Row>

          <Layout.Row>
            <Layout.Column textAlign={enums.textAlignments.LEFT}>
              <Label
                text={
                  <span>
                    Your account uses Enterprise Login. Please use the following link to login{' '}
                    <a href={props.ssoLink}>Enterprise Login</a>.
                  </span>
                }
                hasPadding={false}
                display={enums.display.PLAIN}
                size={enums.sizes.X4}
                isFluid
              />
            </Layout.Column>
          </Layout.Row>

          <Layout.Row>
            <Layout.Column textAlign={enums.textAlignments.LEFT}>
              <Label
                text="If your user does does not have an enterprise login to connect to Grow by Zeta, please contact your company support."
                hasPadding={false}
                display={enums.display.PLAIN}
                size={enums.sizes.X4}
                isFluid
              />
            </Layout.Column>
          </Layout.Row>
        </Layout>
      </div>
    );
  },
});

export default NeedsSsoPanel;
